import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
//使用elementui样式
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

//引入vant
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

import axios from "axios";
Vue.prototype.$axios = axios

//使用适配布局
import 'lib-flexible/flexible.js'
// 字体引入
import '../src/common/font/font.css';
//引入lockr
import Lockr from 'lockr'
import Cookies from 'js-cookie'
window.Lockr = Lockr;
window.Cookies = Cookies;
window.idomain = 'http://tms.oceanscm.com/web';//测试
window.idomains = 'http://tms.oceanscm.com/pas';//测试

// window.idomain = 'http://idalc.com/web';//正式
// window.idomains = 'http://idalc.com/pas';//正式


Vue.config.productionTip = false;
//引入swiper
import VueAwesomeSwiper from 'vue-awesome-swiper';
// 引入swiper样式
import "swiper/dist/css/swiper.css";
//挂载swiper
Vue.use(VueAwesomeSwiper);

//快速点击处理
import preventClick from '../public/statics/js/controlClickState'
Vue.use(preventClick)

//权限测试
// import has from './store/buts.js';



new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
